<template>
  <b-card 
    no-body 
    bg-variant="secondary" 
    title="test"
  >
    <b-card-header>
      <slot />
      <h3>
        <b-badge
          :class="getConditieClass(getConditieGebrek(gebrek))"
          variant="primary"
        >
          Conditie {{ getConditieGebrek(gebrek) }}
        </b-badge>
      </h3>
    </b-card-header>
    <b-card-body body-bg-variant="light">
      <b-row 
        v-for="(foto,index) in gebrek.thumbs" 
        :key="index"
      >
        <b-card 
          no-body 
          class="overflow-hidden" 
          style="max-height:300px;"
        >
          <b-row no-gutters>
            <b-col 
              md="6" 
              class="d-flex align-items-center"
            >
              <b-card-img 
                :src="foto.secure_url" 
                class="rounded-0 img-fluid card-img-top"
              />
            </b-col>
            <b-col md="6">
              <b-card-body :title="(index+1) + ' ' + (foto.titel || 'Geen')">
                <b-card-text>
                  <b-button
                    size="sm"
                    class="mx-2"
                    variant="danger"
                    @click="gebrek.thumbs.splice(index, 1);"
                  >
                    <i class="fa fa-trash" />
                  </b-button>
                  <b-form-text>
                    {{ foto.created_at | formatDateTime }}
                    <small>{{ foto.public_id.substring(0,45)+".." }}</small>
                  </b-form-text>
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </b-row>
      <b-button @click="fotoboek=!fotoboek"> 
        <i class="fa fa-photo mr-2" /> Toevoegen foto
      </b-button>
      <b-modal 
        v-model="fotoboek" 
        title="Kies foto" 
        size="lg"
      >
        <media-grid
          :url="apiCloudResources + '/gebreken'"
          :uploadfolder="cloudUploadPath + '/gebreken'"
          @foto-select="gebrek.thumbs.push($event)"
        />
      </b-modal>
    </b-card-body>
    <b-card-body>
      <b-row>
        <b-col>
          <b-form-group label="Omschrijving">
            <b-textarea v-model="gebrek.omschrijving" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="NEN omschrijving">
            <b-textarea v-model="gebrek.NENomschrijving" />
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Werkzaamheden">
            <b-textarea v-model="gebrek.werkzaamheden" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Bedrag">
            <b-input v-model.number="gebrek.bedrag" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Jaar">
            <b-input 
              v-model="gebrek.jaar" 
              class="mb-2"
            />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Vastzetten">
            <b-checkbox
              v-model="gebrek.stuck"
              v-b-tooltip.hover
              title="Magneten hebben geen invloed het jaar."
            />
            Gepland in {{ gebrek.planning }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Opgelost">
            <b-checkbox v-model="gebrek.uitgevoerd" />
          </b-form-group>
        </b-col>
        <b-col cols="8">
          <b-form-group label="Oplevering">
            <b-select :disabled="true" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body body-bg-variant="dark">
      <b-form-group>
        <b-input-group size="sm">
          <b-input-group-prepend>
            <b-input-group-text>Belang</b-input-group-text>
          </b-input-group-prepend>
          <b-form-radio-group
            v-model="gebrek.belang"
            :options="belangOptions"
            size="sm"
            buttons
            button-variant="outline-secondary"
          />
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group size="sm">
          <b-input-group-prepend>
            <b-input-group-text>Intensiteit</b-input-group-text>
          </b-input-group-prepend>
          <b-form-radio-group
            v-model="gebrek.intensiteit"
            :options="intensiteitOptions"
            size="sm"
            button-variant="outline-secondary"
            buttons
          />
        </b-input-group>
      </b-form-group>
      <b-form-group>
        <b-input-group 
          size="sm" 
          label="Omvang"
        >
          <b-input-group-prepend>
            <b-input-group-text>Omvang</b-input-group-text>
          </b-input-group-prepend>
          <b-form-radio-group
            v-model="gebrek.omvang"
            :options="omvangOptions"
            size="sm"
            buttons
            button-variant="outline-secondary"
          />
        </b-input-group>
      </b-form-group>
      <b-form-group labels-cols="1">
        <b-input-group 
          :append="gebrek.conditieNa.toString()" 
          size="sm" 
          label="Omvang" 
          prepend="Conditie na"
        >
          <b-form-input 
            v-model.number="gebrek.conditieNa" 
            type="range" 
            min="-2" 
            max="9" 
            step="1"
          />
        </b-input-group>
      </b-form-group>
      <aspect-prioriteit :ap="gebrek.ap" />
    </b-card-body>
  </b-card>
</template>
<script>
import { conditieMixin } from "@/mixins/conditieMixin";
import MediaGrid from "@/components/MediaGrid";
import AspectPrioriteit from "@/components/AspectPrioriteit";

export default {
  name: "Conditie",
  components: {
    MediaGrid,
    AspectPrioriteit
  },
  mixins: [conditieMixin],
  props: {
    gebrek: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      fotoboek: false
    };
  },
  computed: {
    apiCloudResources: function() {
      return "/media/cloudinary/" + this.$route.params.id;
    },
    // direct upload path
    cloudUploadPath: function() {
      return "/data/" + this.$route.params.id;
    }
  },
};
</script>